import moment from 'moment';
import LzSApp from '@lz/app/App';

export const LZ_DATE_FIELD_FORMAT = 'YYYY-MM-DD';
export const LZ_TIME_FIELD_FORMAT = 'HH:mm';
export const LZ_DATETIME_FIELD_FORMAT = 'YYYY-MM-DD HH:mm';
export const LZ_DATE_DB_FORMAT = 'YYYY-MM-DD';
export const LZ_TIME_DB_FORMAT = 'HH:mm';
export const LZ_DATETIME_DB_FORMAT = 'YYYY-MM-DD HH:mm';

export const lzFIsEmptyDate = (value?: string): boolean => {
    return typeof value === 'undefined' || !value || '' === value;
};

export const lzFGetFormattedDateTime = (value?: string, format?: string, defaultValue?: string, defaultFormat?: string): string => {
    const isValueEmpty = lzFIsEmptyDate(value);

    if (isValueEmpty && typeof defaultValue !== 'undefined') {
        return defaultValue;
    }

    const theFormat = typeof format === 'undefined' ? defaultFormat || LzSApp.datetime_format : format;

    return isValueEmpty || 'now' === value ? moment().format(theFormat) : moment(value).format(theFormat);
};

export const lzFGetFormattedDate = (value?: string, format?: string, defaultValue?: string): string => {
    return lzFGetFormattedDateTime(value, format, defaultValue, LzSApp.date_format);
};

export const lzFGetFormattedTime = (value?: string, format?: string, defaultValue?: string): string => {
    return lzFGetFormattedDateTime(
        value ? (5 === value.length ? '2000-01-01 ' + value : value) : value, // add date in the start (if its not provided) to avoid invalid date error
        format,
        defaultValue,
        LzSApp.time_format
    );
};

export const lzFGetTimestamp = () => {
    return moment().unix();
};

export const lzFGetMonthStartDate = (format: string, date: string) => {
    return lzFGetFormattedDate(moment(date).startOf('month').format('YYYY-MM-DD HH:mm'), format);
}

export const lzFGetMonthEndDate = (format: string, date: string) => {
    return lzFGetFormattedDate(moment(date).endOf('month').format('YYYY-MM-DD HH:mm'), format);
}

export const lzFGetWeekStartDate = (format: string, date: string) => {
    return lzFGetFormattedDate(moment(date).startOf('week').format('YYYY-MM-DD HH:mm'), format);
}

export const lzFGetWeekEndDate = (format: string, date: string) => {
    return lzFGetFormattedDate(moment(date).endOf('week').format('YYYY-MM-DD HH:mm'), format);
}

export const lzFDateAddDays = (date: string, days: number) => {
    return moment(date).add(days, 'day');
}

export const lzFGetDayOfWeek = (date: string) => {
    // 0 - Sun, 1 - Mon, 3 - Tue, 3 - Wed, 4 - Thu, 5 - Fri, 6 - Sat
    return moment(date).weekday();
}

export const lzFGetWeekdays = (type: 'keys' | 'labels', short?: boolean) => {
    if ('keys' === type) {
        return short ?
            ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] :
            ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    }

    return short ?
        ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] :
        ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
}

export const lzFGetMonths = (type: 'keys' | 'labels', short?: boolean) => {
    if ('keys' === type) {
        return short ?
            ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'] :
            ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
    }

    return short ?
        ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] :
        ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
}
